// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: '4d79b6807',
  buildTime: '2026-11-04T15:44:07.735Z',
} as const;
